const CONSENT_CATEGORY_IDS = {
    necessary: 'C0001',
    statistics: 'C0002',
    preferences: 'C0003',
    marketing: 'C0004'
};

const getEnabledCookies = () => {
    const { Cookiebot } = window;

    if (!Cookiebot || !Cookiebot.consent) {
        return [];
    }

    return Object.entries(CONSENT_CATEGORY_IDS)
        .filter(([category]) => Cookiebot.consent[category] === true)
        .map(([, cookieId]) => cookieId);
};

const grantConsent = (cookieId) => {
    const { Cookiebot } = window;

    if (!Cookiebot || typeof Cookiebot.submitCustomConsent !== 'function') {
        return;
    }

    const { preferences, statistics, marketing } = Cookiebot.consent;

    Cookiebot.submitCustomConsent(
        preferences || cookieId === CONSENT_CATEGORY_IDS.preferences,
        statistics || cookieId === CONSENT_CATEGORY_IDS.statistics,
        marketing || cookieId === CONSENT_CATEGORY_IDS.marketing
    );
};

const openCookieSettings = () => {
    const { Cookiebot } = window;

    if (!Cookiebot || typeof Cookiebot.show !== 'function') {
        return;
    }

    Cookiebot.show();
};

export { CONSENT_CATEGORY_IDS, getEnabledCookies, grantConsent, openCookieSettings };
